const sessionControlBroadcastChannel = new BroadcastChannel('geo-session-control-channel');

export default sessionControlBroadcastChannel;
